// Wraps each letter of .bb-marquee-line[data-bb-marquee-text] in a span
// and applies a staggered animation-delay so the wave ripples across.
(function () {
  var lines = document.querySelectorAll('.bb-marquee-line[data-bb-marquee-text]');
  if (!lines.length) return;
  lines.forEach(function (line, lineIdx) {
    var text = line.getAttribute('data-bb-marquee-text') || line.textContent || '';
    line.textContent = '';
    var i = 0;
    for (var c = 0; c < text.length; c++) {
      var ch = text[c];
      if (ch === ' ') {
        line.appendChild(document.createTextNode(' '));
      } else {
        var s = document.createElement('span');
        s.className = 'bb-marquee-letter';
        s.textContent = ch;
        s.style.animationDelay = (lineIdx * 0.15 + i * 0.06) + 's';
        line.appendChild(s);
        i++;
      }
    }
  });
})();
